import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5c4ab1",
      light: "#9D8DE9",
      // dark: "#1A5B20",
    },
    error: {
      main: "#DC4C64",
    },
    background: {
      default: "#efeef6",
    },
  },

  typography: {
    h2: {
      fontSize: "2rem",
      width: "100%",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 500,
      margin: "20px",
      textAlign: "center",
    },
    h3: {
      fontSize: "1.6rem",
      fontFamily: "'Outfit', sans-serif",
      textAlign: "start",
      height: "30px",
      lineHeight: "30px",
    },
    h4: {
      fontSize: "1.4rem",
      fontFamily: "'Outfit', sans-serif",
      textAlign: "start",
      lineHeight: "30px",
    },
    h5: {
      fontSize: "1.2rem",
      fontFamily: "'Outfit', sans-serif",
      textAlign: "start",
      lineHeight: "20px",
      height: "20px",
    },
    body1: {
      fontSize: "1.4rem",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 300,
    },
  },
  components: {
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontSize: "1.8rem",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: "1.4rem",
        },
        action: {
          "& svg": {
            fontSize: "2rem",
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "1.8rem",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          "& svg": {
            fontSize: "2rem",
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          "& span": {
            fontSize: "1.6rem",
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#D8E9DD",
            color: "#167820",
            svg: {
              color: "#167820",
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "2rem",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        item: {
          margin: 0,
          padding: 0,
          // height: "fit-content",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem",
          textTransform: "none",
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        root: {
          height: "2.6rem",
          ".MuiBadge-badge": {
            fontSize: "1.2rem",
          },
        },
      },
    },
  },
});

export default theme;
